import { useEffect, useState } from "react";
import { TurtleLogo, TurtleButtons, TurtleIntro } from "./components/header";
import { Leaderboard } from "./components/leaderboard";
import { Citations } from "./components/citations";
import { UpdatesSection } from "./components/updates";
import "./index.css";

type ThemeMode = "light" | "dark";

export function App() {
  const [theme, setTheme] = useState<ThemeMode>(() => {
    if (typeof window === "undefined") {
      return "dark";
    }

    const savedTheme = window.localStorage.getItem("theme");
    return savedTheme === "light" ? "light" : "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <div className="mx-auto p-8 pt-2 text-center relative z-10">
			<TurtleLogo />
			<TurtleButtons />
			<TurtleIntro />
			<UpdatesSection />
			<Leaderboard theme={theme} setTheme={setTheme} />
			<Citations />
    </div>
  );
}

export default App;
